import { combineReducers } from 'redux';

import app from './appReducer';
import dirReducer from './dirReducer';
import fileReducer from './fileReducer';
import syncReducer from './syncReducer';
import userReducer from './userReducer';
import iconReducer from './iconReducer';
import versionReducer from './versionReducer';
import settingReducer from './settingReducer';
import portfolioReducer from './portfolioReducer';
import containerReducer from './containerReducer';

import auth from './auth.reducer';
import appV2 from './app.reducer';

export default combineReducers({
  app,
  dir: dirReducer,
  file: fileReducer,
  sync: syncReducer,
  icon: iconReducer,
  user: userReducer,
  version: versionReducer,
  setting: settingReducer,
  portfolio: portfolioReducer,
  container: containerReducer,

  auth,
  appV2,
});
